

import { useState } from "react";
import { Pencil, Save, X } from "lucide-react";

const AwardsAndAccolades = () => {
    const [isEditing, setIsEditing] = useState(false);
    const [formData, setFormData] = useState({
        firstRole: "Designer",
        currentRole: "Designer",
        noticePeriod: "1 Month",
        negotiable: "Yes",
        firstPay: "Bank Account",
        currentPay: "100000",
        gapInEmployment: "Reason",
        performanceRating: "4",
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSave = () => {
        setIsEditing(false);
    };

    return (
        <div className="card">
            <div className="card-header d-flex justify-content-between align-items-center">
                <h5 className="mb-0">Awards and Accolades</h5>
                <div>
                    {isEditing && (
                        <button onClick={handleSave} className="btn btn-success btn-sm me-2">
                            <Save size={18} className="me-1" /> Save
                        </button>
                    )}
                    <button onClick={() => setIsEditing(!isEditing)} className="border-0 bg-transparent">
                        {isEditing ? <X className="text-danger" size={20} /> : <Pencil className="text-primary" size={20} />}
                    </button>
                </div>
            </div>

            <div className="card-block">
                <div className="row mb-3">
                    {/* First Role */}
                    <div className="col-lg-4 mb-3">
                        <label className="form-label">First Role</label>
                        {isEditing ? (
                            <select name="firstRole" className="form-control input-me f-14" value={formData.firstRole} onChange={handleChange}>
                                <option>Web Designer</option>
                                <option>Web Developer</option>
                            </select>
                        ) : (
                            <p className="mb-0 f-13">{formData.firstRole}</p>
                        )}
                    </div>

                    {/* Current Role */}
                    <div className="col-lg-4 mb-3">
                        <label className="form-label">Current Role</label>
                        {isEditing ? (
                            <select name="currentRole" className="form-control input-me f-14" value={formData.currentRole} onChange={handleChange}>
                                <option>Web Designer</option>
                                <option>Web Developer</option>
                            </select>
                        ) : (
                            <p className="mb-0 f-13">{formData.currentRole}</p>
                        )}
                    </div>
                    {/* Notice Period */}
                    <div className="col-lg-4 mb-3">
                        <label className="form-label">Notice Period</label>
                        {isEditing ? (
                            <select name="noticePeriod" className="form-control input-me f-14" value={formData.noticePeriod} onChange={handleChange}>
                                <option>15 Days</option>
                                <option>1 Month</option>
                                <option>2 Month</option>
                            </select>
                        ) : (
                            <p className="mb-0 f-13">{formData.noticePeriod}</p>
                        )}
                    </div>
                    {/* Negotiable */}
                    <div className="col-lg-4 mb-3">
                        <label className="form-label">Negotiable</label>
                        {isEditing ? (
                            <select name="negotiable" className="form-control input-me f-14" value={formData.negotiable} onChange={handleChange}>
                                <option>Yes</option>
                                <option>No</option>
                            </select>
                        ) : (
                            <p className="mb-0 f-13">{formData.negotiable}</p>
                        )}
                    </div>
                    {/* First Pay */}
                    <div className="col-lg-4 mb-3">
                        <label className="form-label">First Pay</label>
                        {isEditing ? (
                            <input type="text" name="firstPay" className="form-control input-me f-14" value={formData.firstPay} onChange={handleChange} />
                        ) : (
                            <p className="mb-0 f-13">{formData.firstPay}</p>
                        )}
                    </div>
                    {/* Current Pay */}
                    <div className="col-lg-4 mb-3">
                        <label className="form-label">Current Pay</label>
                        {isEditing ? (
                            <input type="text" name="currentPay" className="form-control input-me f-14" value={formData.currentPay} onChange={handleChange} />
                        ) : (
                            <p className="mb-0 f-13">{formData.currentPay}</p>
                        )}
                    </div>
                    {/* Gap in employment & Reason */}
                    <div className="col-lg-4 mb-3">
                        <label className="form-label">Gap in employment & Reason</label>
                        {isEditing ? (
                            <input type="text" name="gapInEmployment" className="form-control input-me f-14" value={formData.gapInEmployment} onChange={handleChange} />
                        ) : (
                            <p className="mb-0 f-13">{formData.gapInEmployment}</p>
                        )}
                    </div>
                    {/* Performance Rating */}
                    <div className="col-lg-4 mb-3">
                        <label className="form-label">Performance Rating</label>
                        {isEditing ? (
                            <select name="performanceRating" className="form-control input-me f-14" value={formData.performanceRating} onChange={handleChange}>
                                <option>1 Star</option>
                                <option>2 Star</option>
                                <option>3 Star</option>
                                <option>4 Star</option>
                                <option>5 Star</option>
                            </select>
                        ) : (
                            <p className="mb-0 f-13">{formData.performanceRating}</p>
                        )}
                    </div>
                    
                </div>
            </div>
        </div>
    );
};

export default AwardsAndAccolades;
